import React, { useContext, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import HotelController, { AreaType, DeviceType, RoomType } from '../../controller/HotelController';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import { AuthContext } from '../../navigation/AuthProvider';
import { getNumberToString } from '../../utils/util';
import { useToast } from '../../controller/ToastController';
import HotelDeviceSummaryTable from './HotelDeviceSummaryTable';

const HotelDeviceSetting = () => {
  const showToast = useToast();
  const today = new Date();
  const twoDaysAgo = new Date(today);
  twoDaysAgo.setHours(today.getHours() - 48);

  const [areaName, setAreaName] = useState<string>('');
  const [roomNumber, setRoomNumber] = useState<string>('');
  const [isOpen, setIsOpen] = useState<boolean[]>([]);
  const [isEdit, setIsEdit] = useState<boolean[]>([]);

  const [roomList, setRoomList] = useState<AreaType[]>([]);
  const [editList, setEditList] = useState<AreaType[]>([]);
  const [editRoomNumber, setEditRoomNumber] = useState<string>('');
  const [errorDevice, setErrorDevice] = useState<DeviceType[]>([]);

  const oAuthContext = useContext(AuthContext);
  const user_id = oAuthContext.userInfo.user_id;
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const deviceList = roomList.flatMap((data) => data.room.flatMap((device) => device.device_list));

  const getPowerBoxStatus = (subItem: DeviceType) => {
    // 전원이 상시인데 충전ON
    if (subItem.device_power === 1 && subItem.device_is_charging === 1) return 'on';
    // 전원이 상시인데 충전OFF
    if (subItem.device_power === 1 && subItem.device_is_charging === 0) return 'error';
    // 전원이 비상시인데 전원ON
    if (subItem.device_power === 0 && subItem.device_is_charging === 1) return 'on';
    // 전원이 비상시 이고 와이파이가 비상시인데 와이파이ON 이고 충전OFF
    if (
      subItem.device_power === 0 &&
      subItem.device_wifi_power === 0 &&
      subItem.loggedin_at > subItem.loggedout_at &&
      subItem.device_is_charging === 0
    )
      return 'error';
    return 'off';
  };
  const getWifiBoxStatus = (subItem: DeviceType) => {
    // 와이파이ON
    if (subItem.loggedin_at > subItem.loggedout_at) return 'on';
    if (subItem.loggedin_at !== null && subItem.loggedout_at === null) return 'on';
    // 와이파이가 상시이고 전원이 상시인데 와이파이OFF
    if (
      subItem.device_wifi_power === 1 &&
      subItem.device_power === 1 &&
      subItem.loggedin_at < subItem.loggedout_at
    )
      return 'error';
    // 와이파이가 상시이고 전원이 비상시인데 전원ON 이고 와이파이OFF
    // if (
    //   subItem.device_wifi_power === 1 &&
    //   subItem.device_power === 0 &&
    //   subItem.device_is_charging === 1 &&
    //   subItem.loggedin_at < subItem.loggedout_at
    // )
    //   return 'error';

    return 'off';
  };
  const getAppErrorStatus = (subItem: DeviceType) => {
    // 와이파이ON 이고 device_app_state BACKGROUND
    if (subItem.loggedin_at > subItem.loggedout_at && subItem.device_app_state === 'background')
      return 'error';
  };

  // onChange
  const onChange_area = (e: any) => {
    setAreaName(e.target.value);
  };
  const onChange_roomNumber = (e: any) => {
    setRoomNumber(getNumberToString(e.target.value));
  };
  const onChange_edit_areaName = (e: any, index: number) => {
    let roomTemp = JSON.parse(JSON.stringify(editList));
    roomTemp[index].area_name = e.target.value;
    setRoomList([...roomTemp]);
    setEditList([...roomTemp]);
  };
  const onChange_edit_roomName = (e: any, index: number, subIndex: number) => {
    let roomTemp = JSON.parse(JSON.stringify(editList));
    roomTemp[index].room[subIndex].name = e.target.value;
    setEditList([...roomTemp]);
  };
  const onChange_editRoomNumber = (e: any) => {
    setEditRoomNumber(getNumberToString(e.target.value));
  };

  const changeIsOpen = (index: number) => {
    const dataTemp = isOpen;
    dataTemp[index] = !dataTemp[index];
    setIsOpen([...dataTemp]);
  };
  const changeIsEdit = (index: number) => {
    setEditRoomNumber('');
    const updatedIsEdit = isEdit.map((edit, i) => (i === index ? true : false));

    setIsEdit(updatedIsEdit);
  };

  const addArea = () => {
    if (roomNumber.length > 0) {
      let newAreaTemp: any = {
        area_name: areaName,
        name: [],
      };
      for (let i = 0; i < Number(roomNumber); i++) {
        newAreaTemp.name.push(`${roomList.length + 1}${String(i + 1).padStart(2, '0')}호`);
      }
      console.log(newAreaTemp);
      return newAreaTemp;
    }
  };

  const addRoom = (index: number) => {
    let newListTemp = JSON.parse(JSON.stringify(editList));
    const roomLength = editList[index].room.length;

    if (!isNaN(Number(editRoomNumber))) {
      for (let i = 0; i < Number(editRoomNumber); i++) {
        let newRoomTemp = {
          // number: roomLength + i + 1,
          name: `${index + 1}${String(roomLength + i + 1).padStart(2, '0')}호`,
          device_list: [],
        };
        newListTemp[index].room.push(newRoomTemp);
      }
      console.log('after', newListTemp, editList);
      setEditRoomNumber('');
      setEditList([...newListTemp]);
    }
  };
  const deleteRoom = (index: number, roomIndex: number) => {
    let newListTemp = JSON.parse(JSON.stringify(editList));
    console.log('deviceList', newListTemp[index], index, roomIndex);

    if (newListTemp[index].room[roomIndex].device_list.length > 0) {
      showToast('기기가 연결된 객실은 삭제할 수 없어요', 'error');
    } else {
      // newListTemp[index].room = newListTemp[index].room.filter(
      //   (item: any, index: number) => index !== roomIndex,
      // );
      // console.log('delete', newListTemp);

      newListTemp[index].room[roomIndex].is_deleted = true;
    }
    setEditList([...newListTemp]);
  };

  const checkRequired = () => {
    return areaName.length > 0 && roomNumber.length > 0;
  };

  // API 호출
  const getDeviceList = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
        user_id: user_id,
      };
      const oRes: any = await HotelController.getDevice(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log('getDevice', oResponse);

        if (oResponse.data) {
          setRoomList([...oResponse.data]);
          setEditList([...oResponse.data]);
          let openTemp = new Array(oResponse.data.length).fill(true);
          let editTemp = new Array(oResponse.data.length).fill(false);
          openTemp[0] = true;
          setIsOpen([...openTemp]);
          setIsEdit([...editTemp]);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const setArea = async () => {
    try {
      const areaList = addArea();

      if (areaList) {
        const oParams = {
          store_id: currentStore.value,
          user_id: user_id,
          area_list: [areaList],
        };
        const oRes: any = await HotelController.setArea(oParams);

        if (oRes && oRes.data) {
          const oResponse: any = oRes.data;
          console.log('setArea', oResponse);

          if (oResponse.data) {
            setAreaName('');
            setRoomNumber('');
            getDeviceList();
          }
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getDeviceList();
  }, []);

  const saveEditList = async (index: number) => {
    const oParams = {
      store_id: currentStore.value,
      user_id: user_id,
    };
    await HotelController.editArea({
      store_id: currentStore.value,
      user_id: user_id,
      area_list: editList,
    });

    showToast('적용되었습니다.');

    // const listTemp = roomList;
    // listTemp[index].room = editList[index].room;
    // setRoomList([...listTemp]);
    // const dataTemp = isEdit;
    // dataTemp[index] = false;
    // setIsEdit([...dataTemp]);
    await getDeviceList();
    // console.log('roomList', roomList, listTemp);
  };
  const cancelEditList = (index: number) => {
    console.log('cancel', roomList, editList);
    setEditList([...roomList]);
    const dataTemp = isEdit;
    dataTemp[index] = false;
    setIsEdit([...dataTemp]);
  };

  const getDeviceSummary = async () => {
    let oData: any = {
      store_id: currentStore.value,
      user_id: oAuthContext.userInfo.user_id,
    };

    try {
      const oResp = await StoreController.getDeviceSummary(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok) {
        setErrorDevice(
          oResponse.data.abnormal_device.sort(
            (a: DeviceType, b: DeviceType) => a.name && b.name && a.name.localeCompare(b.name),
          ),
        );
        // 수정필요
        // setErrorDevice(
        //   oResponse.data.abnormal_device
        //     .filter(
        //       (device: DeviceType) =>
        //         !(
        //           device.device_wifi_power === 1 &&
        //           device.device_power === 0 &&
        //           device.device_is_charging === 1 &&
        //           device.loggedin_at < device.loggedout_at
        //         ),
        //     )
        //     .sort((a: DeviceType, b: DeviceType) =>
        //       a.name && b.name ? a.name.localeCompare(b.name) : 0,
        //     ),
        // );
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  useEffect(() => {
    getDeviceSummary();
  }, []);

  return (
    <>
      <Style>
        {deviceList.length > 0 && (
          <div className="contentContainer">
            <HotelDeviceSummaryTable deviceList={deviceList} />
            {/* {deviceList.some((data) => data.device_status === 'checkin') && (
              <div className="checkinDeviceWrap">
                <div className="checkinTitle">
                  <h4>입실한 객실</h4>
                  <p className="noticeText">
                    🔔 입실한 객실이 표시되지 않을 경우 해당 객실은 기기 점검이 필요합니다.
                  </p>
                </div>

                <div className="checkinDevice">
                  {deviceList.map((data) => data.device_status === 'checkin' && <p>{data.name}</p>)}
                </div>
              </div>
            )} */}
            {/* {errorDevice.length > 0 && (
              <div className="errorDeviceWrap">
                <div className="errorTitle">
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_exclamation.svg`} alt="ic" />
                  <h4>기기 확인요청 총 {errorDevice.length}개</h4>
                </div>
                <div className="errorContent">
                  {errorDevice.map((data) => (
                    <div className="errorItem">
                      <h4>{data.name}</h4>
                      {getPowerBoxStatus(data) === 'error' && (
                        <p className="errorTime">충전 불량</p>
                      )}
                      {getWifiBoxStatus(data) === 'error' && (
                        <div className="errorItemWrap">
                          <p className="errorTime">{`인터넷 끊김 시간\n${moment(
                            data.loggedout_at,
                          ).format('YYYY/MM/DD')}\n${moment(data.loggedout_at).format(
                            'HH:mm:ss',
                          )}`}</p>
                        </div>
                      )}
                      {getAppErrorStatus(data) === 'error' && (
                        <p className="errorTime">앱이 종료되었음</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )} */}
          </div>
        )}
        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>구역 설정</h4>
            </div>
            <div className="inputWrap">
              <div className="unit">층</div>
              <input
                type="text"
                placeholder="구역 이름을 입력해주세요  예) 10층"
                value={areaName}
                onChange={onChange_area}
                autoFocus={true}
              />
            </div>
          </div>
          <div className="inputText">
            <div className="title">
              <h4>객실 설정</h4>
            </div>
            <div className="inputWrap">
              <div className="unit">개</div>
              <input
                type="text"
                placeholder="해당 구역의 객실 수를 입력해주세요  예) 100"
                value={roomNumber}
                onChange={onChange_roomNumber}
                autoFocus={false}
              />
            </div>
          </div>
          <button className={`submitButton ${!checkRequired() && 'inactive'}`} onClick={setArea}>
            객실정보 저장
          </button>
        </div>

        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial between">
              <h4>층별 객실 안내</h4>
              <div className="powerWrap">
                <div className="flexCenter">
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_wifi_on.svg`}
                    alt="와이파이"
                    width={16}
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_power_on.svg`}
                    alt="와이파이"
                    width={16}
                  />
                  <h4> 정상</h4>
                </div>
                <div className="flexCenter">
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_wifi_error.svg`}
                    alt="와이파이"
                    width={16}
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_power_error.svg`}
                    alt="와이파이"
                    width={16}
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_app_error.svg`}
                    alt="와이파이"
                    width={16}
                  />
                  <h4>오류(확인 필요)</h4>
                </div>
                <h4 className="power not">기기없음</h4>
              </div>
            </div>
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>
                '기기없음'으로 표시된 객실만 삭제 가능합니다. 연결을 끊으려면 기기의 객실관리에서
                설정해주세요.
              </p>
            </div>
            {roomList.length > 0 ? (
              <div className="categoryList">
                {roomList.map((item: AreaType, index: number) => {
                  return (
                    <div key={index}>
                      <div className={`listItem ${isOpen[index] && 'open'}`}>
                        {isEdit[index] ? (
                          <div
                            style={{
                              width: '25%',
                              textAlign: 'center',
                            }}>
                            <input
                              type="text"
                              value={item.area_name}
                              onChange={(e) => onChange_edit_areaName(e, index)}
                            />
                          </div>
                        ) : (
                          <h4>{item.area_name}</h4>
                        )}

                        <div className="listHeaderButtonWrap">
                          {isEdit[index] ? (
                            <div className="row">
                              <button onClick={() => cancelEditList(index)}>
                                <h5>취소</h5>
                              </button>
                              <button className="save" onClick={() => saveEditList(index)}>
                                <h5>저장</h5>
                              </button>
                            </div>
                          ) : (
                            <img
                              src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
                              alt="수정아이콘"
                              onClick={() => changeIsEdit(index)}
                            />
                          )}
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                              isOpen[index] ? 'up' : 'down'
                            }_grey.svg`}
                            onClick={() => changeIsOpen(index)}
                            width={30}
                            height={30}
                            alt="ic"
                          />
                        </div>
                      </div>
                      {isOpen[index] && (
                        <div className="roomList">
                          {editList[index].room.map((room: RoomType, roomIndex: number) => {
                            return room.device_list.length > 0 ? (
                              <>
                                {room.device_list.map((subItem: DeviceType, subIndex: number) => {
                                  return isEdit[index] ? (
                                    <>
                                      {room.is_deleted === true ? (
                                        <div key={subIndex} className="roomItem remove">
                                          <div className="row">
                                            <input value={room.name} />
                                            <div className="deleteText">
                                              <p>삭제</p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <div key={subIndex} className="roomItem">
                                          <div className="row">
                                            <input
                                              value={room.name}
                                              onChange={(e) =>
                                                onChange_edit_roomName(e, index, roomIndex)
                                              }
                                            />
                                            <div
                                              className="deleteButton"
                                              onClick={() => deleteRoom(index, roomIndex)}>
                                              <img
                                                src={`${process.env.PUBLIC_URL}/svg/ic_close_black.svg`}
                                                alt="룸 삭제"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <div
                                      key={subIndex}
                                      className={`roomItem status ${
                                        // 수정필요
                                        // !(
                                        //   subItem.device_wifi_power === 1 &&
                                        //   subItem.device_power === 0 &&
                                        //   subItem.device_is_charging === 1 &&
                                        //   subItem.loggedin_at < subItem.loggedout_at
                                        // ) &&
                                        subItem.normal === 0
                                          ? 'error'
                                          : new Date(subItem.logged_at) < twoDaysAgo
                                          ? 'longTime'
                                          : ''
                                      } `}>
                                      <h4>{room.name}</h4>
                                      {subItem.device_status !== 'abnormal' && (
                                        <div
                                          className={`roomStatusBox ${
                                            subItem.device_status === 'checkin' && 'checkin'
                                          }`}>
                                          <p>
                                            {
                                              {
                                                alltime: '상시',
                                                checkin: '입실',
                                                checkout: '공실',
                                              }[subItem.device_status]
                                            }
                                          </p>
                                        </div>
                                      )}
                                      <div className="powerListWrap">
                                        <div className={`powerBox ${getPowerBoxStatus(subItem)}`}>
                                          <img
                                            src={`${
                                              process.env.PUBLIC_URL
                                            }/svg/ic_power_${getPowerBoxStatus(subItem)}.svg`}
                                            alt="전원"
                                            width={16}
                                          />
                                          <p>{subItem.device_power === 0 ? '비상시' : '상시'}</p>
                                        </div>
                                        <div className={`powerBox ${getWifiBoxStatus(subItem)}`}>
                                          <img
                                            src={`${
                                              process.env.PUBLIC_URL
                                            }/svg/ic_wifi_${getWifiBoxStatus(subItem)}.svg`}
                                            alt="와이파이"
                                            width={16}
                                          />
                                          <p>
                                            {subItem.device_wifi_power === 0 ? '비상시' : '상시'}
                                          </p>
                                        </div>
                                        {getAppErrorStatus(subItem) === 'error' && (
                                          <div className={`powerBox ${getAppErrorStatus(subItem)}`}>
                                            <img
                                              src={`${
                                                process.env.PUBLIC_URL
                                              }/svg/ic_app_${getAppErrorStatus(subItem)}.svg`}
                                              alt="앱"
                                              width={14}
                                            />
                                            <p>앱 이상</p>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </>
                            ) : isEdit[index] ? (
                              <>
                                {room.is_deleted === true ? (
                                  <div key={roomIndex} className="roomItem remove">
                                    <div className="row">
                                      <input value={room.name} />
                                      <div className="deleteText">
                                        <p>삭제</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div key={roomIndex} className="roomItem">
                                    <div className="row">
                                      <input
                                        value={room.name}
                                        onChange={(e) =>
                                          onChange_edit_roomName(e, index, roomIndex)
                                        }
                                      />
                                      <div
                                        className="deleteButton"
                                        onClick={() => deleteRoom(index, roomIndex)}>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/svg/ic_close_black.svg`}
                                          alt="룸 삭제"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="roomItem status">
                                <h4>{room.name}</h4>
                                <div className="row gap">
                                  <p className={'power not'}>연결기기없음</p>
                                </div>
                              </div>
                            );
                          })}
                          {isEdit[index] && (
                            <div className="editFooter">
                              <input
                                type="text"
                                placeholder="객실 수를 입력해주세요"
                                value={editRoomNumber}
                                onChange={onChange_editRoomNumber}
                                autoFocus={false}
                              />
                              <button className="addButton" onClick={() => addRoom(index)}>
                                <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가" />
                                <h5>새 객실 추가하기</h5>
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="noneWrap">
                <h3>객실을 등록해주세요</h3>
              </div>
            )}
          </div>
        </div>
      </Style>
    </>
  );
};

const isLogin = (data: { loggedin_at: string; loggedout_at: string }) => {
  const loggedin_at = new Date(data.loggedin_at); // 로그인 시간
  const loggedout_at = new Date(data.loggedout_at); // 로그아웃 시간

  return loggedin_at > loggedout_at;
};

export default HotelDeviceSetting;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  .power::before {
    content: '●';
    padding-right: 6px;
    font-size: 10px;
  }
  .power.on::before {
    color: #4dd2ae;
  }
  .power.off::before {
    color: #ff6060;
  }
  .power.not::before {
    color: #ffc700;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }

  input::placeholder,
  textarea::placeholder {
    color: #cecece;
  }

  /* checkinDeviceWrap */
  .checkinDeviceWrap {
    width: 100%;
    margin-bottom: 10px;
    background: #fff;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  .checkinTitle {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    background: #ecf5f3;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding: 6px 28px;
    h4 {
      font-size: 16px;
    }
    p {
      font-size: 12px;
      font-weight: 700;
      color: #ff6060;
    }
  }
  .checkinDevice {
    padding: 10px 28px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    p {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
  }
  /* errorDeviceWrap */
  .errorDeviceWrap {
    width: 100%;
  }

  .notice {
    width: 100%;
    margin-bottom: 12px;
    padding: 0 10px 12px 10px;
    border-bottom: 1px solid #ff6060;

    h3 {
      font-size: 14px;
      line-height: 26px;
      color: #555;
    }
    h3:nth-child(1) {
      color: #ff6060;
    }
  }

  .errorTitle {
    display: flex;
    align-items: center;
    padding: 12px 28px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    background: #ff6060;

    h4 {
      color: #fff;
    }
    img {
      margin-right: 9px;
    }
  }
  .errorContent {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 20px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    background: #ffeeee;

    .errorItem {
      display: flex;
      flex-direction: column;
      align-self: stretch;
      min-width: calc((100% - 40px) / 5);
      max-width: calc((100% - 40px) / 5);
      margin-bottom: 16px;
      text-align: center;

      h4 {
        font-size: 16px;
        font-weight: 500;
        color: #555;
      }
      p {
        font-size: 11px;
        font-weight: 500;
        color: #ff6060;
      }
      p.errorTime {
        font-size: 10px;
        line-height: 14px;
        margin-bottom: 4px;
        white-space: pre-line;
      }
    }
  }
  .errorItemWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  .errorCircle {
    width: 7px;
    height: 7px;
    background: #ff6060;
    border-radius: 5px;
  }
  .flexCenter {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  /* inputText */
  .inputText {
    img {
      cursor: pointer;
    }
    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: flex-start;
      gap: 4px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .greyFont {
        color: #a7a7a7;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
    .title.between {
      justify-content: space-between;
    }
    .powerWrap {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      h4 {
        font-size: 14px;
        line-height: 18px;
        color: #555555;
        font-weight: 500;
      }
    }

    .inputWrap {
      position: relative;
      .unit {
        position: absolute;
        font-size: 16px;
        line-height: 22px;
        color: #a7a7a7;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
      textarea {
        min-height: 120px;
      }
    }
  }

  .row {
    gap: 16px;
  }

  .powerStatusWrap {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-bottom: 4px;
    .powerItem {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #4dd2ae;
      border-radius: 3px;
      padding: 2px;
      gap: 2px;
      p {
        font-size: 12px;
        line-height: 18px;
        color: #fff;
        font-weight: 600;
      }
      img {
        height: 12px;
      }
    }
    .powerItem.error {
      background: #ff6060;
    }
    .powerItem.off {
      background: #a7a7a7;
    }
  }

  .addButton {
    margin-top: 30px;
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;

    h5 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .categoryList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 30px;

    .listItem {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 16px 10px 22px;
      background: #f7f7f7;
      border: 1px solid #e5e5e5;
      border-radius: 5px;

      .row {
        gap: 6px;
      }
      .listHeaderButtonWrap {
        padding: 0;
        position: absolute;
        right: 22px;
        display: flex;
        align-items: center;
        gap: 14px;

        button {
          padding: 4px 16px;
          border: 1px solid #e5e5e5;
          background: #f7f7f7;
          border-radius: 5px;
          h5 {
            font-weight: 500;
            color: #555555;
          }
        }
        button.save {
          border: 1px solid #4dd2ae;
          background: #4dd2ae;
          h5 {
            color: #ffffff;
          }
        }
      }
      h4 {
        color: #2b2b2b;
        font-weight: 500;
      }
    }
    .listItem.open {
      border-radius: 5px 5px 0 0;
    }

    .roomList {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      gap: 1.2%;
      padding: 8px;
      border: 1px solid #e5e5e5;
      border-top: none;
      border-radius: 0 0 5px 5px;

      .editFooter {
        width: 100%;
        padding: 20px;
        padding-top: 10px;

        .addButton {
          margin-top: 10px;
        }
      }

      .roomItem {
        width: 19%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 4px 0;
        padding: 10px 6px;
        .row {
          gap: 0;
        }
        input {
          width: 75%;
          padding: 12px 6px;
          text-align: center;
          border: 1px solid #e5e5e5;
          border-radius: 5px 0 0 5px;
        }
        .deleteButton {
          width: 25%;
          padding: 12px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #e5e5e5;
          border-left: none;
          border-radius: 0 5px 5px 0;
          cursor: pointer;
        }
        .row.gap {
          gap: 6px;
        }
        .power::before {
          padding-right: 2px;
        }
        h4 {
          font-size: 16px;
          color: #2b2b2b;
          font-weight: 500;
        }
      }
      .roomItem.remove .row {
        border-radius: 5px;
        position: relative;
        border: 2px solid #ff6060;

        input {
          width: 100%;
          border-radius: 5px;
          padding: 10px 6px;
          color: #efefef;
        }
        .deleteText {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          background: rgba(255, 96, 96, 0.3);
          height: 100%;

          p {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 500;
            color: red;
          }
        }
      }
      .longTime.longTime {
        border: 1px solid orange;
        .roomStatusBox {
          border-color: orange;
        }
      }
    }
  }
  .roomItem.status {
    position: relative;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    gap: 10px;

    h4 {
      font-size: 16px;
    }
    p {
      font-size: 10px !important;
      line-height: 12px;
      white-space: nowrap;
    }
  }
  .roomItem.status.error {
    border-color: #ff6060;
  }
  .roomStatusBox {
    position: absolute;
    margin: -1px;
    padding: 3px 8px;
    top: 0;
    right: 0;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-right-radius: 0;

    p {
      color: #979797;
    }
  }
  .roomStatusBox.checkin {
    background: #4dd2ae;

    p {
      color: #fff;
    }
  }
  .powerListWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px !important;
  }
  .powerBox {
    margin: 0 auto;
    text-align: center;
    padding: 2px 4px;
    border-radius: 4px;
  }
  .powerBox.off p {
    color: #a7a7a7;
    font-size: 15px;
  }
  .powerBox.error p {
    color: #ff6060;
  }
  .powerBox.on p {
    color: #4dd2ae;
  }
  .battery {
    position: relative;
    display: flex;
    align-items: center;
    height: 14px;

    .chargeDegree {
      position: absolute;
      top: 4px;
      left: 2px;
      height: 7px;
      background: #a7a7a7;
    }
    .chargeDegree.red {
      background: #ff6060;
    }
  }
  .chargeIcon {
    margin-left: -4px;
  }
  .volumeWrap {
    display: flex;
    align-items: center;
    gap: 1px;
    margin-left: 4px;
    p {
      font-size: 8px;
      color: #a7a7a7;
    }
  }

  @media (max-width: 600px) {
    .errorContent {
      gap: 1%;
      .errorItem {
        min-width: 24%;
        max-width: 24%;

        .errorItemWrap {
          gap: 2px;
          p {
            font-size: 9px;
            line-height: 12px;
          }
        }
        p.errorTime {
          font-size: 9px;
          line-height: 12px;
        }
      }
    }
    .categoryList {
      gap: 16px;
      .listItem {
        justify-content: flex-start;
      }
      .roomList {
        .roomItem {
          padding: 6px;
          input {
            padding: 12px 6px;
            font-size: 14px;
          }
          h4 {
            font-size: 14px;
          }
        }
        .editFooter {
          padding: 6px;
        }
      }
    }

    .powerStatusWrap {
      flex-direction: column;
      gap: 4px;
      margin-bottom: 4px;
      .powerItem {
        width: 100%;
        padding: 2px;
        gap: 4px;
      }
      .powerItem.error {
        background: #ff6060;
      }
    }
  }
`;
